<template>
    <div class="d-flex align-items-center card-id">
        <div>
            {{ type }} ID: {{ id }}
        </div>
        <div class="ml-1">
            <a
                :id="'id-copy-clipboard'+id"
                href="#"
                class="copy-to-clipboard"
                :class="{'text-white': variant == 'light' || variant == 'white'}"
                @click.prevent="copyToClipboard"
            >
                <font-awesome-icon :icon="['fad', 'clipboard']"/>
            </a>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/_colors';

.card-id {
    margin-left: -14px;
    margin-top: -14px;

    .copy-to-clipboard {
        display: none;
    }

    &:hover {
        .copy-to-clipboard {
            display: inline-block;
        }
    }
}
</style>

<script>
import copy from 'copy-html-to-clipboard'

export default {
    data: () => ({}),
    props: [
        'id',
        'variant',
        'type', 
    ],
    components: {},
    watch: {},
    computed: {},
    methods: {
        copyToClipboard() {
            copy(this.id, {
                asHtml: false
            })
        }
    }
}
</script>
